package ru.villawonka.app.presentation.screens.favorites.compose

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.getTelegram
import ru.villawonka.app.platform.telegram.model.toDp
import ru.villawonka.app.presentation.design.components.AppButton
import ru.villawonka.app.presentation.design.components.AppButtonSize
import ru.villawonka.app.presentation.design.components.AppButtonType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfaceSecondary
import ru.villawonka.app.presentation.design.theme.surfaceLow
import ru.villawonka.app.presentation.screens.favorites.viewmodel.FavoritesUIState
import ru.villawonka.app.presentation.sharedviews.DefaultErrorStateLayout
import ru.villawonka.app.presentation.sharedviews.DefaultLoadingStateLayout
import ru.villawonka.app.presentation.sharedviews.postList.compose.PostListView
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.stub_no_favorites

@Composable
fun FavoritesRootLayout(state: FavoritesUIState, callbacks: FavoritesCallbacks) {
    val bottomInset = getTelegram()?.getSafeAreaInset()
        ?.bottom
        ?.toDp(LocalDensity.current.density) ?: 0.dp
    val bottomNavigationHeight = 56.dp

    when (state) {
        is FavoritesUIState.Loading -> DefaultLoadingStateLayout()
        is FavoritesUIState.Empty -> FavoritesEmptyDataStub(callbacks)
        is FavoritesUIState.Error -> DefaultErrorStateLayout(
            failure = state.failure,
            onRetryClick = callbacks.onRetryButtonClick
        )
        is FavoritesUIState.Data -> PostListView(
            title = AppResources.strings.favoritesTitle,
            bottomPadding = bottomNavigationHeight + bottomInset,
            posts = state.posts,
            onLoadSimilar = {},
            onLoadNextPage = {},
            hasMoreData = false,
        )
    }
}

@Composable
fun FavoritesEmptyDataStub(callbacks: FavoritesCallbacks) {
    Box(
        modifier = Modifier
            .background(MaterialTheme.colors.surfaceLow)
            .fillMaxSize()
    ) {
        Column(
            modifier = Modifier
                .align(Alignment.Center)
                .padding(16.dp)
            ,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Image(
                painter = painterResource(Res.drawable.stub_no_favorites),
                contentDescription = null
            )
            AppSpacer(8.dp)
            Text(
                text = AppResources.strings.favoritesEmptyLabel,
                style = AppTextStyles.bodyMediumMedium,
                color = MaterialTheme.colors.onSurfaceSecondary,
                textAlign = TextAlign.Center,
                modifier = Modifier.padding(horizontal = 27.dp)
            )
            AppSpacer(16.dp)
            AppButton(
                modifier = Modifier.align(Alignment.CenterHorizontally),
                text = AppResources.strings.favoritesEmptyGoToSearchButton,
                size = AppButtonSize.MEDIUM,
                type = AppButtonType.SECONDARY,
                onClick = callbacks.onGoToSearchButtonClick
            )
        }
    }
}